import { CurrencySettings } from '@ps/user-settings-models';
import { Nullable } from '@ps/utils';

export class LocaleToUSDConversion {
  constructor(
    private readonly _localCurrencyValue: number,
    private readonly _exchangeRateObj: Nullable<CurrencySettings>,
  ) {}

  public convert(): number {
    if (!this._exchangeRateObj?.rate || !this._exchangeRateObj?.crRate) {
      return this._localCurrencyValue;
    }

    const { rate: exchangeRate, crRate } = this._exchangeRateObj;
    const baseAmount = this._localCurrencyValue / exchangeRate;
    return Number(baseAmount - baseAmount * crRate);
  }
}
